import usePostClassRecommendation from '@stores/postClassRecommendation';
import Dynamic from '@base/Dynamic/Dynamic';

const PostClassRecommendation = Dynamic(
  () => import('@cont/ClassVideoPlayer/PostClassRecommendation')
);

export default function RenderPostClassRecommendation() {
  const { isOpen, close, data } = usePostClassRecommendation();

  // Only rendering the element when it's open and data is available
  // to avoid rendering it on every page
  if (!isOpen || !data) {
    return null;
  }

  const { goalUID, classUID, is5minSV } = data || {};
  return (
    <PostClassRecommendation
      // @ts-ignore
      onClose={close}
      goalUID={goalUID}
      classUID={classUID}
      is5minSV={is5minSV}
    />
  );
}
